import React from "react";
import { Box, Typography, Stack, Grid } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import personImage from "../../../../assets/photo.jpg";

const EventAndMemorial: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Grid container spacing={4}>
        <Grid size={{ xs: 12, md: 7 }}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Event Information
          </Typography>

          <Stack spacing={2} sx={{ mt: 2 }}>
            <Stack direction="row" spacing={2}>
              <CalendarTodayIcon
                sx={{ color: "text.secondary", fontSize: 20 }}
              />
              <Box>
                <Typography variant="body2" fontWeight="bold">
                  Date
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Thursday, December 18, 2025
                </Typography>
              </Box>
            </Stack>

            <Stack direction="row" spacing={2}>
              <AccessTimeIcon sx={{ color: "text.secondary", fontSize: 20 }} />
              <Box>
                <Typography variant="body2" fontWeight="bold">
                  Time
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  11:15 AM
                </Typography>
              </Box>
            </Stack>

            <Stack direction="row" spacing={2}>
              <LocationOnIcon sx={{ color: "text.secondary", fontSize: 20 }} />
              <Box>
                <Typography variant="body2" fontWeight="bold">
                  Venue
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Old Georgians Sports Club
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Coordinates: 51.5074, -1.2345
                </Typography>
              </Box>
            </Stack>
          </Stack>
        </Grid>

        <Grid size={{ xs: 12, md: 5 }}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            In Memory Of
          </Typography>

          <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
            <Box
              component="img"
              src={personImage}
              alt="Memorial"
              sx={{
                width: 80,
                height: 80,
                objectFit: "cover",
                borderRadius: 1,
              }}
            />
            <Box>
              <Typography variant="body2" fontWeight="bold" gutterBottom>
                Jane Doe
              </Typography>
              <Typography variant="body2" color="text.secondary">
                This service will honor and preserve the memory of your loved
                one.
              </Typography>
            </Box>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default EventAndMemorial;
